import type { ComponentPropsWithoutRef } from 'react';
import { Alert, AlertAction, Text } from '@simplywallst/ui-core';
import { RichTextEditor } from '@/components/RichTextEditor';
import { StyledGridWrapper } from './styled';

interface Props
  extends Pick<
    ComponentPropsWithoutRef<typeof RichTextEditor>,
    | 'onSave'
    | 'onUpdate'
    | 'onError'
    | 'defaultContent'
    | 'isLoading'
    | 'isSuccess'
    | 'saveButtonText'
  > {
  errorMessage: string;
  onDimissAlert: () => void;
}

const getPromptOption = (): string => {
  const options = [
    'Are you optimistic about the future of this company?',
    `What strengths or competitive advantages does this company have?`,
    `Where do you think this company will be in 5 years' time?`,
    `What interests you about this stock?`,
    `What’s your narrative on this stock’s future?`,
    `What makes this company investment potential to you?`,
    `Are there any recent developments that impact your existing thesis on this stock?`,
    `Are there any risks that concern you about this stocks future prospects?`,
    `What business outcomes are driving your opinion of this stock’s future?`,
    `How confident are you on your opinions of this stock’s future prospects?`,
  ];

  return options[Math.floor(Math.random() * options.length)];
};

export const NotesRichTextEditor = ({
  defaultContent,
  errorMessage,
  isLoading,
  isSuccess,
  saveButtonText = 'Save',
  onUpdate,
  onError,
  onSave,
  onDimissAlert,
}: Props) => {
  const isError = errorMessage.length > 0;
  return (
    <StyledGridWrapper
      templateRows={isError ? `max-content auto` : `1fr`}
      gap={isError ? `16px` : undefined}
      data-cy-id="note-editor"
    >
      {isError && (
        <Alert
          data-cy-id="notes-error-alert"
          styleType="negative"
          actions={
            <AlertAction shouldDismissAlert={false} onClick={onDimissAlert}>
              OK
            </AlertAction>
          }
        >
          <Text typography="xSmall" color="white">
            {errorMessage}
          </Text>
        </Alert>
      )}
      <RichTextEditor
        defaultContent={defaultContent}
        isLoading={isLoading}
        isSuccess={isSuccess}
        saveButtonText={saveButtonText}
        characterLimit={10000}
        placeholderText={getPromptOption()}
        onUpdate={onUpdate}
        onError={onError}
        onSave={onSave}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={!defaultContent}
      />
    </StyledGridWrapper>
  );
};
